<div *ngIf="hideSidebar">
    <div class="sidenav-bar" >
        <div class="sidenav-header row">
            <div class="sidenav-menu col-2">
                <span (click)="closeSideBar()">
                    ☰
                </span>
            </div>
            <div class="sidenav-label col-6">
                <a>
                    <span>
                        <a href="/cinejoy">
                            cinejoy
                        </a>
                    </span>
                </a>
            </div>
            <div class="sidenav-search col-2">
               <div></div>
            </div>
            <div class="sidebar_cart col-2" >
                <div></div>
            </div>
        </div>
        <div class="first-nav row">
            <div class="col-1 col-sm-2 d-md-none d-lg-block col-lg-2 col-xl-1">
                <span style="display: none;">&nbsp;</span>
            </div>
            <div class="col-11 col-sm-10 col-md-11 col-lg-10 g-0  marginLeft">
                <div class="nav-top">
                    
                    <div style="display: inline-block;" class="sec-nav-list font-poppins-regular">
                        <ul>
                           
                            <li><a [routerLink]="['/cinejoy/premiere/lineup']" routerLinkActive="active">Spotlights</a></li>
                            <li><a [routerLink]="['/cinejoy/showcase']"  routerLinkActive="active">Showcase</a></li>
                            <!-- <li><a href="/cinejoy/celebrations/home">Celebrations</a></li> -->
                            <li><a [routerLink]="['/cinejoy/screening-parties/']" routerLinkActive="active" style="display: inline-block;">Meetups</a></li>
                       </ul>
                    </div>
                </div>
                <div class="nav-bottom font-poppins-regular">
                    <div>
                    <div>
                        <div>
                            <a class="my-ticket" (click)="openMyTicket()">My Tickets</a>
                            <a class="my-ticket" href="/cinejoy/passholders-watchlist">My Watchlist</a>
                        </div>
                        
                        <a id="passport" [routerLink]="['/cinejoy/passport']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  >Passport</a>
                        <a [routerLink]="['/cinejoy/passport/community']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" >Community Passports</a>
    
                        <div >
    
                        <a href="/cinejoy/how-to">How-To/Tks</a>
                        <a href="/cinejoy/about">About</a>
                        <a [routerLink]="['/cinejoy/showcase/archive']"  routerLinkActive="active" #D7BE69>Archive</a>
    
                        </div>
    
                    </div>
                    <div style="margin-top:10px;">
                        <a href="/">
                            <img src="assets/images/Creatics_MainLogoUpdateHoriz2_20170915.png" alt="home-page"
                                width="100px">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
</div>